import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { sendJson } from '@hcr/api/shared'

import type { HoldingBookingWeekCancelPayloadDto, ProblemDetailsDto } from '../../dtos'
import type { AuthorizedRequestParams } from '../../models'
import { createAuthorizationHeader } from '../../utils'

export const createHoldingBookingWeekCancelMutation =
  (baseUrl: string) =>
  (
    { idToken }: AuthorizedRequestParams,
    options?: Partial<UseMutationOptions<void, ProblemDetailsDto, HoldingBookingWeekCancelPayloadDto>>
  ) =>
    useMutation<void, ProblemDetailsDto, HoldingBookingWeekCancelPayloadDto>({
      ...options,
      mutationFn: body =>
        sendJson({
          body,
          headers: createAuthorizationHeader(idToken),
          method: 'POST',
          url: `${baseUrl}/user/holdings/cancel`,
        }),
    })
